<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4
      class="card-title"
      style="
        padding-top: 30px;
        padding-bottom: 30px;
        background-color: #c3c3c338;
      "
    >
      <b>Contact Us </b>
    </h4>
    <div class="container" style="padding-top: 20px" >
         <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 40%;">
        <img src="../assets/animation.gif" />
      </p>
    </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <form v-on:submit.prevent="handleSubmit();">
            <div class="form-group row">
              <label for="inputName" class="col-sm-2 col-form-label"
                >Name</label
              >
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="inputName"
                  placeholder="Name"
                  v-model="name"
                  maxlength="15"
                  required=""
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputEmail" class="col-sm-2 col-form-label"
                >Email</label
              >
              <div class="col-sm-10">
                <input
                  type="email"
                  class="form-control"
                  id="inputEmail"
                  placeholder="Email"
                  v-model="email"
                  required=""
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPhone" class="col-sm-2 col-form-label"
                >Phone No.</label
              >
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  id="inputPhone"
                  placeholder="Phone Number"
                  v-model="phone"
                  maxlength="10"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label"
                >Comments</label
              >
              <div class="col-sm-10">
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="5"
                  placeholder="Comments"
                  v-model="subject"
                  maxlength="500"
                  required=""
                ></textarea>
              </div>
            </div>
            <div class="form-group row" style="padding-top: 25px">
              <div class="col-sm-12">
                <button type="submit" class="btn btn-success mb-2">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"
import Navbar from "./navbar";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    Navbar,
  },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      subject: "",
      loading: false,
    };
  },
  methods: {
    handleSubmit: function () {
        this.loading = true;
      var data = {};
      data["name"] = this.name;
      data["email"] = this.email;
      data["phone"] = this.phone;
      data["subject"] = this.subject;
      axios({
        url: "https://api.indiansnakes.org/contactus/add",
        method: "POST",
        data: data,
      })
        .then((response) => {
            if(response.data.status == true){
                this.loading = false
                alert('Success! You will be contacted back soon')
                window.location.href = '/';
            }
            else{
                alert('Please try again')
            }
           
          
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>